import AirportService from "../../services/airport.service";

const state = {
    AirportsList: [],
    isActiveModal: false,
    UpdateAirportList: []
};
const mutations = {
    set_airport(state, payload) {
        state.AirportsList = payload;
    },
    clean_airport(state)
    {
        state.AirportsList = [];
    },
    set_updateairport(state, payload) {
        state.UpdateAirportList = payload;
    },
    set_close_open_modal(state) {
        state.isActiveModal = !state.isActiveModal
    },
    set_clear_updateairport_list(state) {
        state.UpdateAirportList = [];
    }
};
const actions = {

    async GetAirports({commit},payload) {
        await commit("clean_airport");
        const airports = await AirportService.GetAirportsService(payload);
        await commit("set_airport", airports);
        return airports;
    },

    async GetAirportById({commit}, payload) {
        console.log("payload module getairportby id")

        const airport = await AirportService.GetAirportsServiceById(payload);
        await commit("set_updateairport", airport);
        return airport
    },

    async UpdateAirport({dispatch,commit}, payload) {
        const airport = await AirportService.UpdateAirport(payload);
        dispatch("GetAirports");
        commit("set_clear_updateairport_list");
        return airport
    },

    async deleteAirport({dispatch}, payload) {
        const airport = await AirportService.DeleteAirport(payload);
        dispatch("GetAirports");
        return airport
    },

    async AddAirport({dispatch}, payload) {
        const airport = await AirportService.AddAirport(payload);
        dispatch("GetAirports");
        return airport
    },

    async openCloseModal({commit}) {
        await commit("set_close_open_modal");
        await  commit("set_clear_updateairport_list");
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
